import { render, staticRenderFns } from "./Beneficiarios.vue?vue&type=template&id=baa66782&scoped=true"
import script from "./Beneficiarios.vue?vue&type=script&lang=js"
export * from "./Beneficiarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa66782",
  null
  
)

export default component.exports